import React from 'react';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import { ImageInput, SmallHeader } from '../../index.js';
import THEME from '../../../theme.js';
import ColorUpdater from './ColorUpdater.js';
import q from '@debbie/cortex/dist/query.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { collectorsEntity } from '@debbie/cortex/dist/collectors/index.js';
const Layout = (props) => {
    const { collector, lang } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, lang.collectors.layout),
        React.createElement(SmallHeader, null, lang.collectors.logoFileIdPlaceholder),
        React.createElement(ImageInput, { image: collector.logo, onChange: async (file) => {
                try {
                    await collectorsAPI.update(collector.collectorId, {
                        logoFileId: file ? file.fileId : null,
                    });
                    q.invalidate(keys.write.modify(collectorsEntity, collector.collectorId));
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            } }),
        React.createElement(SmallHeader, null, lang.collectors.letterFrontLogoFileIdPlaceholder),
        React.createElement(ImageInput, { image: collector.letterFrontLogo, onChange: async (file) => {
                try {
                    await collectorsAPI.update(collector.collectorId, {
                        letterFrontLogoFileId: file ? file.fileId : null,
                    });
                    q.invalidate(keys.write.modify(collectorsEntity, collector.collectorId));
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            } }),
        React.createElement(SmallHeader, null, lang.collectors.themePlaceholder),
        React.createElement(ColorUpdater, { key: "COLOR_ACCENT", entity: "COLOR_ACCENT", id: collector.collectorId, theme: collector.theme, placeholder: "Accent", defaultColor: THEME.COLOR_ACCENT }),
        React.createElement(ColorUpdater, { key: "COLOR_PRIMARY", entity: "COLOR_PRIMARY", id: collector.collectorId, theme: collector.theme, placeholder: "Primary", defaultColor: THEME.COLOR_PRIMARY }),
        React.createElement(ColorUpdater, { key: "COLOR_SECONDARY", entity: "COLOR_SECONDARY", id: collector.collectorId, theme: collector.theme, placeholder: "Secondary", defaultColor: THEME.COLOR_SECONDARY })));
};
export default Layout;
//# sourceMappingURL=Layout.js.map